import { setConfig } from '@icon-park/svg/es'

setConfig(
  {
    size: '100%',
    strokeWidth: 4,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    prefix: 'd',
    theme: 'outline',
    colors: {
      outline: {
        fill: 'currentColor',
        background: 'transparent',
      },
      filled: {
        fill: 'currentColor',
        background: 'var(--color-white)',
      },
      twoTone: {
        fill: 'currentColor',
        twoTone: 'var(--color-grey-5)',
      },
      multiColor: {
        outStrokeColor: 'currentColor',
        outFillColor: 'var(--color-grey-5)',
        innerStrokeColor: 'var(--color-white)',
        innerFillColor: 'var(--color-grey-2)',
      },
    },
  },
)

export * from '@icon-park/svg/es/map'
export * as Presets from './src'
